export default {
  title: '工場管理',
  addFactory: '工場追加',
  factoryInfo: '工場情報',
  factoryInfoPlaceholder: '工場番号、工場名を入力してください',
  langRequired: '言語バージョンを選択してください',
  factoryNo: '工場番号',
  factoryName: '工場名',
  factoryAddress: '工場住所',
  addModal: '工場追加',
  editModal: '工場編集',
  factoryNoPlaceholder: '工場番号を入力してください',
  factoryNamePlaceholder: '工場名を入力してください',
  factoryAddressPlaceholder: '工場住所を入力してください',
  requiredFactoryNo: '工場番号を入力してください',
  requiredFactoryName: '工場名を入力してください',
};
